<template>
    <div>
        <el-card v-loading="loading" class="box-card" v-if="loading">
            <div style="width: 100%;height: 300px;"></div>
        </el-card>
        <el-card v-loading="loading" class="box-card" v-for="(plan_info, index) in plans" :key="plan_info.id">
            <div style="position: relative;">
                <div>
                    <div :class="plan_info.collection===1?'group_plan_collection':'group_plan_un_collection'">
                        <div style="position: absolute;"
                             :class="plan_prediction_direction(province_score_chongwenbao[plan_info.group_forecast_low_score])"></div>
                        <div class="group_plan_name">
                            {{ province_score_gailv[plan_info.group_forecast_low_score] || '' }}%
                            {{ province_score_chongwenbao[plan_info.group_forecast_low_score] || '' }}
                        </div>
                        <div class="group_plan_majors">
                            <span
                                :class="plan_info.collection===1?'group_plan_collection_major':'group_plan_un_collection_major'">
                                <span v-if="plan_info.majors">
                                    {{ plan_info.school_name }} {{ plan_info.major_group_code }}<span
                                    v-if="plan_info.major_group_code.length > 0">组</span>
                                </span>
                            </span>
                            <span :class="plan_info.collection===1?'collection_new':'un_collection_new'"
                                  v-if="plan_info.group_new_major === 1">
                                新
                            </span>
                        </div>
                        <div v-if="favorite_value == 1"
                             style="float: right;height:40px;line-height: 40px;text-align: center;padding-right: 10px;margin-top: 10px;">
                            <el-select v-model="plan_info.user_score_rank" filterable placeholder="修改顺序"
                                       style="width: 100px;" @change="rank_change($event, plan_info)">
                                <el-option
                                    v-for="item in select_rank"
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                />
                            </el-select>
                        </div>
                        <div v-if="favorite_value != 1 && collect_plan_index[plan_info.danlie_group_key]"
                             style="float: right;height:40px;line-height: 40px;text-align: center;padding-right: 10px;margin-top: 10px;">
                            <span
                                style="float: right;padding: 0 10px;cursor: pointer;border: 1px solid white;background-color:white;color:#E93A29;border-radius: 5px;">
                                {{ collect_plan_index[plan_info.danlie_group_key] }}
                            </span>
                        </div>
                        <div v-if="batch_type === 'major_class' || favorite_value == 1"
                             style="float: right;height:40px;line-height: 40px;text-align: center;padding-right: 10px;margin-top: 10px;">
						<span v-if="plan_info.collection === 1"
                              style="float: right;padding: 0 20px;cursor: pointer;border: 1px solid white;background-color:white;color:#E93A29;border-radius: 5px;"
                              @click="un_chose_favorite(index, plan_info, 2)">取消选择</span>
                            <span v-else>
							<span
                                style="float: right;padding: 0 20px;cursor: pointer;border: 1px solid #E93A29;background-color:#E93A29;color:white;border-radius: 5px;"
                                @click="favorite(index, plan_info, 1)">选择</span>
						</span>
                        
                        </div>
                    </div>
                    <div>
                        <div class="group_plan_content">
                            <div style="text-align: center;cursor: pointer;" v-if="plan_info.school_logo.length > 0"
                                 @click="school_infos(plan_info.school_id, plan_info.school_name)">
                                <img style="width:55%" :src="plan_info.school_logo">
                            </div>
                            <div v-else>
                                <el-icon style="width:55%">
                                    <School style="width:100%;height:100%;"/>
                                </el-icon>
                            </div>
                            <div style="text-align: center;cursor: pointer;font-weight: bold"
                                 @click="school_infos(plan_info.school_id, plan_info.school_name)">
                                {{ plan_info.school_name }}
                            </div>
                            <div style="text-align: center;font-size:12px;margin-top: 5px;">
                                [{{ plan_info.nature_str }}]
                                <span v-if="plan_info.school_guarantee_rate !== ''">
                        [{{ plan_info.school_guarantee_rate }}]
                    </span>
                                <span v-else-if="plan_info.postgraduate_str !== ''">[{{
                                        plan_info.postgraduate_str
                                    }}]</span>
                            </div>
                            <div v-if="plan_info.school_pre != undefined && plan_info.school_pre.length > 0"
                                 style="text-align: center;font-size: 12px;margin: 0 auto;padding: 10px;">
                                历史沿革: {{ plan_info.school_pre }}
                            </div>
                            <div style="text-align: center;font-size: 12px;margin-top: 10px;cursor:pointer;"
                                 @click="school_maps(plan_info.school_name)">
                                <span class="iconfont_small">&#xe64b;</span>{{ plan_info.address }}
                            </div>
                        </div>
                        <div style="margin-top:30px;margin-bottom:30px;float: left;width: 20%;">
                            <div class="group_plan_recruit_tag" style="text-align: left;">
                                <div
                                    style="border: #898989 1px dashed;border-radius: 5px;margin-right: 20px;margin-bottom:10px;padding: 5px;"
                                    v-if="plan_info.foreign_rules.length > 0 || plan_info.foreign_study_mode.length > 0 || plan_info.foreign_universities.length > 0">
                                    <div v-if="plan_info.postgraduate === 1" style="margin-bottom: 20px;">
                                        {{ plan_info.type_str }}
                                    
                                    </div>
                                    <div v-else style="margin-bottom: 20px;">{{ plan_info.type_str }}</div>
                                    <div>
                                        <div v-if="plan_info.foreign_universities.length > 0"
                                             style="font-size:12px;margin-bottom: 5px;">合作院校:
                                            {{ plan_info.foreign_universities }}
                                        </div>
                                        <div v-if="plan_info.foreign_study_mode.length > 0"
                                             style="font-size:12px;margin-bottom: 5px;color: #e8320a">就读模式:
                                            {{ plan_info.foreign_study_mode }}
                                        </div>
                                        <div v-if="plan_info.foreign_rules.length > 0" style="font-size:14px;">
                                            <a target="_blank" :href="plan_info.foreign_rules">查看招生简章</a>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <div style="margin-bottom: 20px;">{{ plan_info.type_str }}</div>
                                </div>
                                <el-popover placement="top-start" :width="200" trigger="hover"
                                            :content="system_tips_list[1]['name']">
                                    <template #reference>
                                        <el-tag >{{ system_tips_list[1]['name'] }}:
                                            <span style="font-weight: bold">{{
                                                    plan_info.group_forecast_low_score
                                                }}</span>
                                        </el-tag>
                                    </template>
                                </el-popover>
                            </div>
                            <div class="group_plan_school_tag">
                                <el-tag type="info">
                                    校友会：{{ plan_info.xyh_sort < 10000 ? plan_info.xyh_sort : '无' }}
                                </el-tag>
                                <el-tag type="info">
                                    软科：{{ plan_info.ruanke_sort < 10000 ? plan_info.ruanke_sort : '无' }}
                                </el-tag>
                                <el-tag type="info">
                                    QS：{{ plan_info.qs_sort < 10000 ? plan_info.qs_sort : '无' }}
                                </el-tag>
                            </div>
                            <div class="group_plan_school_tag">
                                <el-tag type="success" v-for="(label, label_index) in plan_info.label_list"
                                        :key="label_index">
                                    {{ label }}
                                </el-tag>
                            </div>
                        </div>
                        <div class="group_plan_major_list" style="border-left: 1px #EBEBEB solid;">
                            <div>
                                <div>招生计划</div>
                                <el-row>
                                    <el-col :span="4">
                                        <div class="group_plan_major_info_desc">
                                            <span>人数</span>&nbsp;|&nbsp;<span>{{ plan_info.group_num }}</span>
                                        </div>
                                    </el-col>
                                    <el-col :span="8" :offset="1">
                                        <div class="group_plan_major_info_desc">
										<span style="float: left;padding-left: 20px;">
											<span>选科</span>&nbsp;|&nbsp;<span>{{
                                                plan_info.major_group_rule
                                            }}</span>
										</span>
                                            <span
                                                v-if="plan_info.xuanke_rule['all'] !== undefined || plan_info.xuanke_rule[base_info.xuanke] !== undefined"
                                                style="float: right;padding-right: 20px;color: #24C599">选科匹配</span>
                                            <span v-else
                                                  style="float: right;padding-right: 20px;color: #999999">选科不匹配</span>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                            <div style="margin-top: 10px;">
                                <div>统计 ( 录取人数 / 线差 / 最低分 / 最低位次 )</div>
                                <div class="group_plan_major_info_desc"
                                     style="height: 30px;line-height: 30px;padding-left: 20px;">
                                    <div style="width: 33%;display: inline-block;text-align: left;"
                                         v-for="(info, year) in plan_info.group_history_data">
                                        <div style="height: 30px;line-height: 30px;display: inline-block;"
                                             v-if="info.number_basics !== ''">
                                            ({{ year }})
                                            {{ info.number_basics }}&nbsp;/&nbsp;
                                            {{ info.line_diff_basics }}&nbsp;/&nbsp;
                                            {{ info.low_score_basics }}&nbsp;/&nbsp;
                                            {{ info.precedence_basics }}
                                        </div>
                                        <div style="height: 30px;line-height: 30px;display: inline-block;" v-else>
                                            ({{ year }}) 未招生
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div :src="pull_up" @click="show_more_info(index)"
                     style="margin: 0 auto;width:100%;display: flex;justify-content: center;align-items: center;">
                    <el-button type="danger">
                        <el-icon v-if="plan_info.show_more">
                            <ArrowUpBold/>
                        </el-icon>
                        <el-icon v-else>
                            <ArrowDownBold/>
                        </el-icon>
                        <span v-if="plan_info.show_more">收起</span>
                        <span v-else>展开</span>
                        (<span v-if="show_chose_plan">已选: {{
                            chose_plans_num[plan_info.danlie_group_key] || 0
                        }} /</span>
                        包含:{{ plan_info.sub_plan_ids_length }})
                    </el-button>
                </div>
                <div style="position:relative;margin:0 auto;width:100%;display: flex;justify-content: center;">
                    <div v-if="plan_info.show_more === true" style="width: 100%;">
                        <GroupPlanInfo
                            :plans="sub_plans[plan_info.danlie_group_key]"
                            :favorite_value="favorite_value"
                            :sub_select_rank="sub_select_rank"
                            :sub_collect_plan_index="sub_collect_plan_index"
                            :province_score_gailv="province_score_gailv"
                            :province_score_chongwenbao="province_score_chongwenbao"
                            :system_tips_list="system_tips_list"
                            :user_power="user_power"
                            @show_majors_job="show_majors_job"
                            @sub_rank_change="sub_rank_change"
                            @un_favorite="un_favorites"
                            @favorite="favorite"
                            @no_match_major="no_match_majors"
                            @school_info="school_infos"
                            @school_map="school_maps"
                        >
                        </GroupPlanInfo>
                    </div>
                    <div class="show_more_btn" v-if="plan_info.show_more == true" :src="pull_up"
                         @click="show_more_info(index, 1)">
                        <el-icon class="show_more_plan_img">
                            <ArrowUpBold/>
                        </el-icon>
                    </div>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
import GroupPlanInfo from "@/components/GroupPlanInfo";
import pull_up from '@/assets/pull_up.png'
import drop_down from '@/assets/drop_down.png'
import http from "@/utils/http";
import api from "@/api";
import axios from "axios";
import {School} from "@element-plus/icons";
import ClassPlanList from "@/components/ClassPlanList.vue";

export default {
    name: 'group_plan',
    props: {
        plans: Array,
        sub_plans: Array,
        select_rank: Array,
        sub_select_rank: Array,
        collect_list: {
            type: Array,
            default: []
        },
        province_score_gailv: Array,
        province_score_chongwenbao: Array,
        search_type: Number,
        show_chose_plan: {
            type: Boolean,
            default: true
        },
        favorite_value: Number,
        loading: Boolean,
        batch_pre: String,
        system_tips_list: Object,
        user_power: Object,
        rank_change: {type: Function, default: null},
        show_majors_job: {type: Function, default: null},
        change: {type: Function, default: null},
        sub_plans_list: {type: Function, default: null},
        un_favorite: {type: Function, default: null},
        favorite: {type: Function, default: null},
        no_match_major: {type: Function, default: null},
        school_info: {type: Function, default: null},
        school_map: {type: Function, default: null},
    },
    components: {
        ClassPlanList,
        School,
        GroupPlanInfo
    },
    data() {
        return {
            drop_down: drop_down,
            pull_up: pull_up,
            application_form_id: 0,
            oss_sheng_list: {},
            tableData: [],
            batch_type: '',
            base_info: {},
            show_major_label: 1,
            chose_plans_num: {},
            collect_plan_index: {},
            sub_collect_plan_index: {},
        }
    },
    watch: {
        collect_list: {
            handler(new_list, old_list) {
                //console.log('---------------handler(new_list, old_list) {---------------')
                //console.log(new_list)
                this.chose_plans_num = []
                this.collect_plan_index = {}
                this.sub_collect_plan_index = {}
                for (let i in this.collect_list) {
                    let length = 0
                    let key = this.collect_list[i]['danlie_group_key']
                    this.sub_collect_plan_index[key] = {}
                    
                    if (this.collect_list[i]['list']) {
                        length = this.collect_list[i]['list'].length
                        
                        for (let j in this.collect_list[i]['list']) {
                            this.sub_collect_plan_index[key][this.collect_list[i]['list'][j]['plan_id']] = (parseInt(j) + 1)
                        }
                    } else if (this.collect_list[i]['sub_plan_ids']) {
                        length = this.collect_list[i]['sub_plan_ids'].length
                    }
                    this.chose_plans_num[this.collect_list[i]['danlie_group_key']] = length
                    this.collect_plan_index[key] = (parseInt(i) + 1)
                }
            },
            deep: true
        }
    },
    mounted() {
    },
    created() {
        this.batch_type = localStorage.getItem('batch_type') || ''
        let base_info = localStorage.getItem('base_info') || ''
        if (base_info !== null && base_info !== 'null' && base_info !== '[]' && base_info !== '' && base_info !== 'undefined') {
            this.base_info = JSON.parse(base_info)
        }
    },
    computed: {
        plan_prediction_direction() {
            return function (info) {
                if (info === '冲') {
                    return 'group_plan_major_sprint'
                } else if (info === '稳') {
                    return 'group_plan_major_stable'
                } else {
                    return 'group_plan_major_floors'
                }
            }
        }
    },
    methods: {
        rank_change(e, info) {
            this.$emit('rank_change', {'info': info, 'type': 1})
        },
        sub_rank_change(param) {
            this.$emit('rank_change', param)
        },
        get_sheng_oss_list() {
            let that = this
            let url = api.oss.sheng_list.replace('placeholder', this.province_id) + '?t=' + (Date.now() + '')
            axios.get(
                url, {}
            ).then(function (res) {
                that.oss_sheng_list = res.data
            }).catch(function (err) {
            });
        },
        show_majors_job(e) {
            //console.log(e)
            this.$emit('show_majors_job', e)
        },
        un_chose_favorite(index, plan_info, type = 2) {
            this.$emit('un_favorite', {"index": index, "list": plan_info, "del_all": 1, "type": type})
        },
        un_favorites(param) {
            this.$emit('un_favorite', param)
        },
        favorite(index, plan_info, type = 1) {
            this.$emit('favorite', {"index": index, "list": plan_info, "type": type})
        },
        no_match_majors(e) {
            //console.log(e)
            this.$emit('no_match_major', e)
        },
        school_infos(e) {
            //console.log(e)
            this.$emit('school_info', e)
        },
        school_maps(e) {
            //console.log(e)
            this.$emit('school_map', e)
        },
        show_more_info(index) {
            let match_id = parseInt(index)
            this.plans[match_id].show_more = !this.plans[match_id].show_more
            let obj = {
                school_id: this.plans[index]['school_id'],
                major_group_code: this.plans[index]['major_group_code'],
                danlie_biaoshi: this.plans[index]['danlie_biaoshi'],
                danlie_group_key: this.plans[index]['danlie_group_key'],
                sub_plan_ids: this.plans[index]['sub_plan_ids'],
                major_limit: this.plans[index]['major_limit'],
            }
            this.change_list(obj)
        },
        change_list(obj) {
            this.$emit('sub_plans_list', obj)
        },
    }
}
</script>
<style scoped>
.box-card {
    border: 0;
    margin-top: 15px;
}

.box-card >>> .el-card__body {
    padding: 0;
}

.box-card >>> .el-card__header {
    padding: 0;
}

.group_plan_name {
    position: absolute;
    height: 60px;
    width: 60px;
    line-height: 60px;
    padding-right: 10px;
    text-align: right;
    border-radius: 5px;
    color: white
}

.group_plan_majors {
    float: left;
    margin-left: 85px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    padding-right: 10px;
}

.group_plan_action {
    float: right;
    height: 40px;
    line-height: 40px;
    text-align: center;
    padding-right: 10px;
    margin-top: 10px;
}

.group_plan_selected {
    float: right;
    padding: 0 20px;
    cursor: pointer;
    border: 1px solid white;
    background-color: white;
    color: #E93A29;
    border-radius: 5px;
}

.group_plan_select {
    float: right;
    padding: 0 20px;
    cursor: pointer;
    border: 1px solid #E93A29;
    background-color: #E93A29;
    color: white;
    border-radius: 5px;
}

.group_plan_major_sprint {
    border-top: 60px solid #F3AB50;
    border-right: 18px solid transparent;
    height: 0;
    width: 60px;
}

.group_plan_major_floors {
    border-top: 60px solid #24C599;
    border-right: 18px solid transparent;
    height: 0;
    width: 60px;
}

.group_plan_major_stable {
    border-top: 60px solid #4D94F1;
    border-right: 18px solid transparent;
    height: 0;
    width: 60px;
}

.group_plan_collection {
    height: 60px;
    width: 100%;
    background-color: #E93A29;
}

.group_plan_un_collection {
    height: 60px;
    width: 100%;
    background-color: #F2F2F2;
}

.group_plan_collection_major {
    font-size: 20px;
    margin-right: 10px;
    color: #F2F2F2;
}

.group_plan_un_collection_major {
    font-size: 20px;
    margin-right: 10px;
    color: #333333;
}

.group_plan_content {
    margin-top: 30px;
    margin-bottom: 15px;
    float: left;
    width: 20%;
}

.group_plan_school_tag >>> .el-tag--light {
    margin-left: 0px;
    margin-right: 5px;
    margin-bottom: 5px;
}

.group_plan_recruit_tag >>> .el-tag--light {
    margin-left: 0px;
    margin-right: 5px;
    margin-bottom: 5px;
}

.group_plan_major_list {
    float: left;
    margin-top: 30px;
    margin-bottom: 20px;
    padding-left: 20px;
    width: 57%;
    height: 230px;
    overflow-y: auto;
}

.group_plan_major_info_desc {
    background-color: #F8F8F8;
    border-radius: 5px;
    margin-top: 10px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    font-size: 12px;
}

.group_plan_major_remarks {
    background-color: #F8F8F8;
    border-radius: 5px;
    margin-top: 10px;
    min-height: 30px;
    line-height: 30px;
    text-align: left;
    font-size: 12px;
}

.show_more_up_btn {
    position: absolute;
    top: 0;
    height: 25px;
    width: 25px;
    background-color: #dedfe0;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
}

.show_more_btn {
    position: absolute;
    bottom: 0;
    height: 25px;
    width: 25px;
    background-color: #dedfe0;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
}

.show_more_plan_img {
    margin: 0 auto;
    height: 15px;
    width: 15px;
}

.collection_new {
    color: #F2F2F2;
    font-size: 16px;
}

.un_collection_new {
    color: #e8320a;
    font-size: 16px;
}
</style>
